import { render } from "./TextBody.vue?vue&type=template&id=77959c7e&scoped=true"
import script from "./TextBody.vue?vue&type=script&lang=js"
export * from "./TextBody.vue?vue&type=script&lang=js"

import "./TextBody.vue?vue&type=style&index=0&id=77959c7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77959c7e"]])

export default __exports__